export const deCodeBase64 = (dataFile) => {
    let newText = "";
    if (dataFile) {
        if (dataFile.base64String) {
            let type = dataFile.file.type.split("/")[0];
            let suf = "";
            switch (type) {
                case "video":
                    suf = /^data:video\/[a-z]+;base64,/;
                    break;
                case "image":
                default:
                    suf = /^data:image\/[a-z]+;base64,/;
                    break;
            }

            newText = dataFile.base64String.replace(suf, "");
        }
    }
    return newText;
};

export const deCodeBase64_2 = (dataFile) => {
    let newText = "";
    if (dataFile) {
        if (dataFile.base64String) {
            let type = dataFile.file.type.split("/")[0];
            let suf = "";
            if (type === "application") {
                newText = dataFile.base64String.split("base64,")[1];
            } else {
                switch (type) {
                    case "video":
                        suf = /^data:video\/[a-z]+;base64,/;
                        break;
                    case "image":
                    default:
                        suf = /^data:image\/[a-z]+;base64,/;
                        break;
                }

                newText = dataFile.base64String.replace(suf, "");
            }
        }
    }
    return newText;
};
